import { useEffect } from 'react';
import { createReconnectingWebSocket } from '@/lib/ws-reconnect.js';

export const DISPLAY_STAFF_WS_EVENT = 'fixflow-display-staff-ws';

/** Subscribes staff app to display side-channel WebSocket (`/ws/display/:storeId/sig`). */
export function useDisplayStaffBridge(storeId: string | undefined) {
  useEffect(() => {
    if (!storeId) return;

    const socket = createReconnectingWebSocket({
      path: `/ws/display/${storeId}/sig`,
      onMessage: (event) => {
        try {
          const data = JSON.parse(event.data as string) as { type?: string };
          if (data.type === 'ping') return;
          window.dispatchEvent(new CustomEvent(DISPLAY_STAFF_WS_EVENT, { detail: data }));
        } catch {
          /* ignore */
        }
      },
    });

    return () => socket.close();
  }, [storeId]);
}
